import {map} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import * as SearchActions from '../search/search.action';
import * as AssetActions from './assets.action';

// update since/limit and kick the search
export const mapToSearchPrerequisitesToGetMore = (action$, store$) =>
  action$.pipe(
    ofType(AssetActions.PAGE_SELECTED, AssetActions.PAGESIZE_UPDATED),
    map(() => {
      const {assets} = store$.value;
      const limit = assets.pageSize;
      const since = (assets.currentPage - 1) * assets.pageSize;
      return SearchActions.updatePrerequisites({
        limit: limit,
        since: since
      });
    })
  );
